// Central site metadata used to build absolute canonical / Open Graph URLs and
// structured data. Base URL is build-time configurable via VITE_SITE_URL.
export const SITE_URL = (
  (import.meta.env.VITE_SITE_URL as string | undefined) || 'https://www.zenzers4life.com'
).replace(/\/+$/, '')

export const SITE_NAME = 'Zenzers'
export const SITE_TAGLINE = 'Proactive Geriatric Care'
export const SITE_LOCALE = 'en_US'

/** Default share card — 1200x630, generated by scripts/gen-assets.sh into public/. */
export const OG_IMAGE = '/og-default.jpg'
export const OG_IMAGE_WIDTH = 1200
export const OG_IMAGE_HEIGHT = 630
export const OG_IMAGE_ALT =
  'Zenzers — engineering the extraordinary in geriatric remote monitoring'

/** Build an absolute URL from a root-relative path or pass through an absolute one. */
export function absoluteUrl(path = '/'): string {
  if (/^https?:\/\//.test(path)) return path
  return new URL(path, SITE_URL).toString()
}
